// @flow

export { isLocalFx } from './is-local';
